import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="footer dark-background" style={{ padding: "10px 0" }}>
      <div className="container footer-top" style={{ padding: "10px 0" }}>
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="index.html" className="logo d-flex align-items-center">
              <span className="sitename">ULead</span>
            </a>
          </div>
        </div>
      </div>
      {/* Contact Information Section */}
      <div className="container text-center mt-3" style={{ color: "white", padding: "10px 0" }}>
        <p>For more information, please contact:</p>
        <p>
          <strong>Email:</strong>{" "}
          <a
            href="mailto:patience.karua@costech.or.tz"
            style={{ color: "white", textDecoration: "none" }}
          >
            patience.karua@costech.or.tz
          </a>
        </p>
      </div>
      {/* Copyright Section */}
      <div className="container copyright text-center mt-3" style={{ padding: "10px 0" }}>
        <p>
          © <span>Copyright</span>{" "}
          <strong className="px-1 sitename">ULead</strong>{" "}
          <span>All Rights Reserved</span>
        </p>
        <div className="credits" style={{ paddingTop: "5px" }}>
          {/* All the links in the footer should remain intact. */}
          Designed by{" "}
          <a href="https://www.linkedin.com/in/emmanuel-jeremiah-12b25b285/">
            dSkills@EA
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
